var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner"},[_vm._v(" 短信平台设置 ")])}
var staticRenderFns = []

export { render, staticRenderFns }